// eslint-disable-next-line no-undef
export const generateGGDriveLink = (fileId) => `${process.env.REACT_APP_API_BASE_URL}/files/get-file/${fileId}`;
